import { Directive, ElementRef, Input, OnInit } from '@angular/core';

/**
 * We must watch height of window and set max-height in px because it is the only way how to
 * prevent list overflowing the parent or setting height too large
 */
@Directive({
    selector: '[heightWatcherDirective]'
})
export class HeightWatcherDirective implements OnInit {

    private static readonly paddingOverflowSizeDefault = 15;
    @Input() paddingSize = 16;

    private paddingOverflowSize: number;
    private offsetHeightOld: number;

    private container: HTMLElement;
    private previousSibling: HTMLElement;
    private parent: HTMLElement;

    constructor(private elementRef: ElementRef) {
    }

    ngOnInit() {
        // set padding values
        this.paddingOverflowSize = this.paddingSize + HeightWatcherDirective.paddingOverflowSizeDefault;

        this.container = this.elementRef.nativeElement as HTMLElement;
        this.previousSibling = this.container.previousElementSibling as HTMLElement;
        this.parent = this.container.closest('div[detail-container]') as HTMLElement;

        if (this.parent) {
            this.changeElementHeightToEnableScrolling();
        }
    }

    private changeElementHeightToEnableScrolling() {
        this.offsetHeightOld = this.parent.offsetHeight;

        // find if parent is overflowing
        const padding = this.parent.offsetWidth < this.parent.scrollWidth ?
            this.paddingOverflowSize : this.paddingSize;

        const height = this.parent.offsetHeight - this.previousSibling.offsetHeight - padding;

        this.container.style.maxHeight = height + 'px';
    }

    ngAfterViewChecked() {
        if (this.offsetHeightOld === this.parent?.offsetHeight) {
            return;
        }
        this.changeElementHeightToEnableScrolling();
    }
}
